import MuiIconButton from '@mui/material/IconButton';
import { forwardRef } from 'react';
import {
  customVariantClasses,
  customShapeClasses,
} from '../../theme/overrides/IconButton';
import getPrefixClassNames from '../../utils/getPrefixClassNames';
import { Props } from './types';

const IconButton = <C extends React.ElementType>(
  { children, className, ...otherProps }: Props<C>,
  ref: React.ForwardedRef<HTMLSpanElement>,
) => {
  const {
    variant = 'contained',
    color = 'primary',
    shape = 'squareRounded',
  } = otherProps;

  return (
    <MuiIconButton
      className={`${getPrefixClassNames(customVariantClasses[variant], customShapeClasses[shape])} ${className}`}
      color={color}
      {...otherProps}
      ref={ref}
    >
      {children}
    </MuiIconButton>
  );
};

IconButton.displayName = 'IconButton';

export default forwardRef(IconButton) as <C extends React.ElementType>(
  props: Props<C> & {
    ref?: React.ForwardedRef<HTMLUListElement>;
  },
) => ReturnType<typeof IconButton>;
